import { Button } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { reportsConstants } from 'locale/team'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { CapabilityToggleList } from '../../generic/teamCapabilities'
import { getCapabilityTogglesForRole } from './capabilityToggles'
import type { WizardData } from './types'

export type Step3CapabilitiesProps = {
  value: WizardData
  onChange: (next: WizardData) => void
  onBack: () => void
  onSendInvite: () => void
  isSubmitting?: boolean
  testId?: string
}

const Heading = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.color.neutral.color3};
`

const Hint = styled.div`
  margin-top: 4px;
  color: ${({ theme }) => theme.color.neutral.color5};
  font-size: 16px;
  line-height: 24px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
`

const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.color.neutral.color8};
`

export const Step3Capabilities = ({
  value,
  onChange,
  onBack,
  onSendInvite,
  isSubmitting,
  testId
}: Step3CapabilitiesProps) => {
  const { t } = useTranslation(NAMESPACE.TEAM)

  return (
    <div data-testid={testId}>
      <Heading>{t(reportsConstants.WIZARD_STEP3_TITLE)}</Heading>
      <Hint>{t(reportsConstants.WIZARD_STEP3_HINT)}</Hint>
      <Body>
        <CapabilityToggleList
          toggles={getCapabilityTogglesForRole(value.role)}
          value={value.capabilities}
          onChange={(key, next) =>
            onChange({
              ...value,
              capabilities: { ...value.capabilities, [key]: next }
            })
          }
          testId={testId}
        />
      </Body>
      <Footer>
        <Button onClick={onBack}>{t(reportsConstants.WIZARD_BACK)}</Button>
        <Button
          variant="primary"
          onClick={onSendInvite}
          isLoading={isSubmitting}
          disabled={isSubmitting}
        >
          {t(reportsConstants.WIZARD_SEND_INVITE)}
        </Button>
      </Footer>
    </div>
  )
}
